import { Controller } from "@hotwired/stimulus"

// Settings preview for the payment-success effect picker: picking a radio
// clones the matching <template> (holding real shared/_celebration markup with
// an empty once-key, so it always plays) into the body. Stimulus boots the
// clone's celebration controller, which autoplays and removes it — what the
// owner previews is exactly what checkout will play.
export default class extends Controller {
  static targets = ["template"]

  play({ params: { effect } }) {
    // Rapid re-picks must not stack overlays — drop any live one first.
    document.querySelectorAll(".celebration-overlay").forEach((el) => el.remove())
    const template = this.templateTargets.find((t) => t.dataset.effect === effect)
    if (template) document.body.appendChild(template.content.cloneNode(true))
  }
}
